import React from 'react';
import SkeletonLoader from '../../../components/ui/SkeletonLoader';

const CatalogCardSkeleton = () => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden shadow-elevation-sm">
      <SkeletonLoader variant="thumbnail" />
      <div className="p-4">
        <SkeletonLoader variant="title" className="mb-2" />
        <div className="flex items-center gap-4 mb-3">
          <SkeletonLoader variant="text" className="w-20" />
          <SkeletonLoader variant="text" className="w-16" />
        </div>
      </div>
      <div className="p-4 border-t border-border flex gap-2">
        <SkeletonLoader variant="button" className="flex-1" />
        <SkeletonLoader variant="button" className="flex-1" />
        <SkeletonLoader variant="button" className="w-10" />
      </div>
    </div>
  );
};

export default CatalogCardSkeleton;